import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { key: String }

  get storageKey() {
    return this.hasKeyValue ? `announcement_dismissed_${this.keyValue}` : "announcement_dismissed";
  }

  dismiss() {
    localStorage.setItem(this.storageKey, Date.now());
    this.element.remove();
  }

  connect() {
    const dismissed = localStorage.getItem(this.storageKey);
    if (dismissed) {
      const dismissedDate = new Date(parseInt(dismissed));
      const daysSinceDismissal =
        (Date.now() - dismissedDate) / (1000 * 60 * 60 * 24);

      if (daysSinceDismissal < 7) {
        this.element.remove();
      }
    }
  }
}
